import { IOffsetPrice } from "../@interfaces/quote.interface";

const currencies: { [key: string]: string } = {
  USD: "$",
  NZD: "$",
  AUD: "$",
  GBP: "£",
  CNY: "¥",
  JPY: "¥",
  EUR: "€",
  HKD: "$",
};

export const formatPriceTextOnly = (price: IOffsetPrice, displayCurrencyName: boolean) => {
  const symbol = currencies[price.currency.toUpperCase()];
  const displayCurrencyCode = displayCurrencyName ? price.currency.toUpperCase() : '';

  return symbol
  ? `${symbol}${price.value?.toLocaleString(
    undefined, { minimumFractionDigits: price?.zeroDecimalCurrency ? 0 : 2 }
  )} ${displayCurrencyCode}`
  : `${price.value?.toLocaleString(
    undefined, { minimumFractionDigits: price?.zeroDecimalCurrency ? 0 : 2 }
  )} ${price.currency.toUpperCase()}`
};

